import { render } from "./template_form_management.html?vue&type=template&id=16d3101c&external"
import script from "./template_form_management.js?vue&type=script&lang=js&external"
export * from "./template_form_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__